<template>
	<div class="container">
		<banner/>
		<div class="main">
			<div class="content">
				<div v-for="item in dataList" :key="item.id">
					<articleCard :item="item"/>
				</div>
				<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
			</div>
			<div class="aside">
				<asideNews/>
				<asideCircle/>
				<asideFollow/>
				<!-- <asideActive/> -->
			</div>
		</div>
	</div>
</template>

<script>
	import banner from './banner.vue'
	import articleCard from '@/components/articleCard'
	import asideNews from '@/components/aside/news'
	import asideCircle from '@/components/aside/recommendCircle'
	import asideFollow from '@/components/aside/recommendFollow'
	import asideActive from '@/components/aside/activeUser'
	import Pagination from '@/components/pagination'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'home',
		components: {
			banner,
			articleCard,
			asideNews,
			asideCircle,
			asideFollow,
			asideActive,
			Pagination
		},
		data(){
			return {
				pageSize: 30,
				pageNum: 1,
				userId: '',
				dataList: [],
				total: 0
			}
		},
		created(){
			this.getDataList()
		},
		methods: {
			//获取首页数据列表
			async getDataList(){
				let param = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					userId: localStorage.getItem('userId')||''
				}
				ajaxParam(param)
				const res = await post('v1/index/postList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			pageChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			}
		}
	}
</script>

<style scoped lang="less">
	.main{
		display: flex;
		justify-content: space-between;
		width: 1180px;
		margin: 20px auto;
		.content{
			flex: 1;
			background: #fff;
			padding: 40px;
			border-radius: 10px;
		}
		.aside{
			width: 300px;
			margin-left: 20px;
		}
	}
</style>
